import cn from 'classnames';
import { IAdminDeviceGroup } from 'types';
import { AdminListCheckbox } from '../AdminListCheckbox';
import { AdminListRowCell } from '../AdminListRowCell';
import { StyledAdminDeviceGroupsListRow } from './styles';

export interface IDeviceGroupsListRowProps {
  children?: React.ReactNode;
  selected: boolean;
  onSelect: (id: IAdminDeviceGroup['id'], selected: boolean) => void;
  group: IAdminDeviceGroup;
}

export const groupFieldMap: Record<
  string,
  (group: IDeviceGroupsListRowProps['group']) => React.ReactNode
> = {
  name: (group) => group.name,
  normalHashrate: (group) => group.normalHashrate,
  adjust: (group) => group.adjust,
  yesterdayHashrate: (group) => group.yesterdayHashrate,
  payment: (group) => group.payment,
};

export const AdminDeviceGroupsListRow = ({
  group,
  selected,
  onSelect,
}: IDeviceGroupsListRowProps) => {
  const selectRowHandler = () => {
    onSelect(group.id, !selected);
  };

  return (
    <StyledAdminDeviceGroupsListRow>
      <div className="admin-list-cell-container select">
        <AdminListCheckbox checked={selected} onChange={selectRowHandler} />
      </div>
      {Object.entries(groupFieldMap).map(([title, valueGetter]) => (
        <div key={title} className={cn('admin-list-cell-container', title.toLowerCase())}>
          <AdminListRowCell>{valueGetter(group)}</AdminListRowCell>
        </div>
      ))}
    </StyledAdminDeviceGroupsListRow>
  );
};
